var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6107 15.6474L18.6076 15.7952C18.6076 16.1381 18.3783 16.439 18.0484 16.5297C17.9806 16.548 17.9128 16.5571 17.8457 16.5571C17.5821 16.5571 17.3307 16.4192 17.1913 16.1853C14.1734 11.1126 10.1749 10.9686 8.70287 11.1118V15.0334C8.70287 15.3412 8.51771 15.62 8.23278 15.7374C7.94707 15.8562 7.62021 15.7899 7.40231 15.572L0.545172 8.71491C0.247292 8.41692 0.247292 7.93537 0.545172 7.63749L7.40231 0.780351C7.62021 0.563201 7.94707 0.496906 8.23278 0.615024C8.51771 0.73236 8.70287 1.01123 8.70287 1.31904V4.36971C13.0869 4.54951 16.9116 7.50952 18.1368 11.751C18.6663 13.5878 18.626 15.0804 18.6107 15.6452L18.6107 15.6474ZM16.9839 12.084C17.2271 12.9278 17.3371 13.6905 17.3846 14.3056C15.9452 12.3524 14.3394 11.216 12.83 10.5853C11.0375 9.83635 9.4594 9.83252 8.58663 9.91746L7.50287 10.0229V13.9755L1.70352 8.1762L7.50287 2.37685V5.5215L8.6537 5.5687C12.5273 5.72757 15.9034 8.34433 16.9839 12.084Z",
    fill: "#4B4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageReply);
export default __webpack_public_path__ + "static/media/message_reply.8e8d029a85a68dba7e8af405b15fbb20.svg";
export { ForwardRef as ReactComponent };